export const budgetChapterMutationFrag = `
    id
`;

export const budgetChapterFrag = `
    id
    name
`;
